import { render, staticRenderFns } from "./OrganizationDetailSessionAuthorizations.vue?vue&type=template&id=cc2a766e"
import script from "./OrganizationDetailSessionAuthorizations.vue?vue&type=script&lang=js"
export * from "./OrganizationDetailSessionAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports